import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';

import {Wrapper} from 'system/wrapper';
import {Message} from 'components/message';

const EmailConfirmation = props => {
  const centeredStyle = {
    textAlign: 'center'
  }
  const redirectAfterTime = time => {
    setTimeout(() => {props.history.replace('/')}, time)
  }

  return (
    <Wrapper>
      <Grid>
        <Row>
          <Col style={centeredStyle}>
            <Message>
              Електронну пошту підтверджено!
            </Message>
          </Col>
        </Row>
      </Grid>
      {redirectAfterTime(3000)}
    </Wrapper>
  )
}

export default EmailConfirmation



// WEBPACK FOOTER //
// ./src/auth/emailConfirmation.js